import { render, staticRenderFns } from "./ListaPrestados.vue?vue&type=template&id=79139e01"
import script from "./ListaPrestados.vue?vue&type=script&lang=js"
export * from "./ListaPrestados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports